<template>
  <customModal 
    :containermd="true" 
    @closeModal="handleClose"
  >
    <template #title>
        Activate Account
    </template>

    <template #body>
      <div>
        <div class="row">
          <!-- First Name -->
          <div class="col-12 col-md-6 pr-md-1 mt-2">
            <label for="first-name">
              First Name 
              <sup><i class="fa fa-asterisk required"></i></sup></label>
            <input
              id="first-name"
              type="text"
              class="form-control"
              maxlength="100"
              v-model.trim="values.firstName"
              placeholder="Enter first name"
            />
            <span class="d-block errorClass" v-if="errors[0] === false">
              Please enter first name
            </span>
          </div>

          <!-- Last Name -->
          <div class="col-12 col-md-6 mt-2">
            <label for="last-name">Last Name <sup><i class="fa fa-asterisk required"></i></sup></label>
            <input
              id="last-name"
              type="text"
              class="form-control"
              maxlength="100"
              v-model.trim="values.lastName"
              placeholder="Enter last name"
            />
            <span class="d-block errorClass" v-if="errors[1] === false">
              Please enter last name
            </span>
          </div>

          <!-- Username -->
          <div class="col-12 col-md-6 mt-2">
            <label for="username">Username <sup><i class="fa fa-asterisk required"></i></sup></label>
            <input
              id="username"
              type="text"
              class="form-control"
              maxlength="10"
              v-model.trim="values.userName"
              placeholder="Enter username (5-10 characters)"
            />
            <span class="d-block errorClass" v-if="errors[8] === false">
              Username must be 5–10 characters
            </span>
          </div>

          <!-- Primary Email -->
          <div class="col-12 col-md-6 mt-2">
            <label for="primary-email">Primary Email <sup><i class="fa fa-asterisk required"></i></sup></label>
            <input
              id="primary-email"
              type="email"
              class="form-control"
              maxlength="500"
              v-model.trim="values.emailIdPrimary"
              placeholder="Enter primary email"
            />
            <span class="d-block errorClass" v-if="errors[2] === false">
              Enter a valid email address
            </span>
          </div>

          <!-- Secondary Email -->
          <div class="col-12 col-md-6 mt-2">
            <label for="secondary-email">Secondary Email</label>
            <input
              id="secondary-email"
              type="email"
              class="form-control"
              maxlength="500"
              v-model.trim="values.emailIdSecondary"
              placeholder="Enter secondary email"
            />
            <span class="d-block errorClass" v-if="errors[3] === false">
              Enter a valid email address
            </span>
          </div>

          <!-- User Type -->
          <div class="col-12 col-md-6 mt-2">
            <label for="user-type">User Type <sup><i class="fa fa-asterisk required"></i></sup></label>
            <select
              id="user-type"
              class="form-control"
              v-model="values.userType"
               disabled
            >
              <option value="" disabled>Select user type</option>
              <option value="Internal">Internal</option>
              <option value="External">External</option>
            </select>
            <span class="d-block errorClass" v-if="errors[4] === false">
              Please select a user type
            </span>
          </div>

          <!-- Role -->
          <div class="col-12 col-md-6 mt-2">
            <label for="role">Role <sup><i class="fa fa-asterisk required"></i></sup></label>
            <select
              id="role"
              class="form-control"
              v-model="multiSelectList[0]"
               disabled
            >
              <option value="" disabled>Select a role</option>
              <option
                v-for="option in roleList"
                :key="option.roleID"
                :value="option.roleID"
              >
                {{ option.roleName }}
              </option>
            </select>
            <span class="d-block errorClass" v-if="errors[6] === false">
              Please select a role
            </span>
          </div>

          <!-- Country -->
          <div class="col-12 col-md-6 mt-2">
            <label for="country">Country</label>
            <select
              id="country"
              class="form-control"
              v-model="values.country"
            >
              <option value="">Select country</option>
              <option>China</option>
              <option>India</option>
              <option>Japan</option>
              <option>Mexico</option>
              <option>Russia</option>
              <option>South Africa</option>
              <option>United Kingdom</option>
              <option>United States</option>
              <option>Vietnam</option>
            </select>
          </div>

          <!-- Date of Birth -->
          <div class="col-12 col-md-6 mt-2">
            <label for="dob">Date of Birth</label>
            <input
              id="dob"
              type="text"
              class="form-control"
              v-model="values.dateOfBirth"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
              placeholder="Select date"
            />
            <span class="d-block errorClass" v-if="errors[7] === false">
              Invalid date
            </span>
          </div>

          <!-- Phone Number -->
          <div class="col-12 col-md-6 mt-2">
            <label for="phone">Phone Number</label>
            <input
              id="phone"
              type="text"
              class="form-control"
              maxlength="10"
              v-model.trim="values.phoneNumber"
              placeholder="Enter phone number (10 digits)"
            />
            <span class="d-block errorClass" v-if="errors[5] === false">
              Invalid phone number (10 digits)
            </span>
          </div>

          <!-- Address 1 -->
          <div class="col-12 col-md-6 mt-2">
            <label for="address1">Address 1</label>
            <input
              id="address1"
              type="text"
              class="form-control"
              maxlength="1000"
              v-model.trim="values.addressLineOne"
              placeholder="Enter address line 1"
            />
          </div>

          <!-- Address 2 -->
          <div class="col-12 col-md-6 mt-2">
            <label for="address2">Address 2</label>
            <input
              id="address2"
              type="text"
              class="form-control"
              maxlength="1000"
              v-model.trim="values.addressLineTwo"
              placeholder="Enter address line 2"
            />
          </div>

          <!-- Active & Lock checkboxes -->
          <div class="col-12 mt-2 d-flex align-items-center">
            <div class="i-checks mr-4">
              <label class="mr-2">
                <input type="checkbox" v-model="values.active" />
                Active
              </label>
            </div>
            <div class="i-checks">
              <label class="mr-2">
                <input type="checkbox" v-model="values.lock" />
                Lock
              </label>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
   
          <button
            class="btn btn-primary cancel_btn py-0 px-4 mx-3"
            type="button"
            @click="clearForm"
          >
            <p class="mb-0">Clear</p>
          </button>

          <button
            type="button"
            class="btn btn-primary save_btn py-0 px-4"
            :disabled="loading"
            :class="{ 'disabled-btn-cls': loading }"
            @click="addUser"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': !loading,
                'opacity-1': loading,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Loading"
              />
            </div>
            <p
              class="mb-0"
              :class="{
                'opacity-1': !loading,
                'opacity-0': loading,
              }"
            >
              {{ $t("navigations.save") || "Activate" }}
            </p>
          </button>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script src="./ActivateAccountPopup.js"></script>

<style scoped>
.browser-btn {
  border: 1px solid #e7eaec;
  background-color: #e7eaec;
  border-radius: 0.25rem;
}
.errorClass {
  color: #d9534f;
  font-size: 0.85rem;
}
.opacity-0 {
  opacity: 0;
}
.opacity-1 {
  opacity: 1;
}
.disabled-btn-cls {
  opacity: 0.6;
  cursor: not-allowed;
}
.required {
  color: #d9534f;
  font-size: 0.7rem;
}
.save_btn {
  position: relative;
}
.toc-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.loading-btn-img {
  width: 20px; 
}
.required {
  color: red;
  font-size: 7px;
  vertical-align: super;
}

.errorClass {
  color: #ed5565;
  font-size: 12px;
}

.col-form-label {
  font-weight: 500;
}
</style>